<div class="columns-2 md:columns-2 gap-6">
  <div class="space-y-6">
    <ng-container *ngFor="let fact of quickFacts.slice(0, 2)">
      <ng-container
        *ngTemplateOutlet="
          factBox;
          context: {
            title: fact.title,
            description: fact.description
          }
        "></ng-container>
    </ng-container>
  </div>

  <div class="space-y-6 pt-10">
    <ng-container *ngFor="let fact of quickFacts.slice(2, 4)">
      <ng-container
        *ngTemplateOutlet="
          factBox;
          context: {
            title: fact.title,
            description: fact.description
          }
        "></ng-container>
    </ng-container>
  </div>
</div>

<ng-template #factBox let-title="title" let-description="description" let-tourId="tourId">
  <div
    class="h-48 p-6 rounded-lg border border-gray-200 shadow-md flex flex-col justify-center items-center"
    data-test="quick-fact-box">
    <h2 class="text-3xl text-raspberry-darker font-bold mb-2">{{ title }}</h2>
    <p class="text-grape-darker font-bold my-0 text-center">{{ description }}</p>
  </div>
</ng-template>
